<template>
    <layout-main :banner="banner" subtitle="关于迪孚">
        <template v-slot:content>
            <div class="about-us">
                <div class="title">南京迪孚网络科技有限公司</div>
                <p class="text">公司位于美丽城市南京的我们是一家专注于医疗无线网络和物联网开发的企业。多年来，我们致力于为医疗机构提供先进的解决方案，以提升医疗服务的效率和质量。目前，我们拥有多种产品，包括wifi无线网络解决方案、输液监控系统、无线体温采集系统、婴儿防盗系统、特殊患者防走失系统、医院资产定位系统、智慧病房交互系统、移动护理信息系统、院内冷链管理系统以及设备能效管理系统等。这些产品覆盖了医院的各个关键领域，为医院提供了全方位的支持和服务。</p>
                <p class="text">公司秉承“科技创新，服务社会”的企业理念，致力于为医疗机构提供全面、高效、安全的信息化解决方案，以提升医疗服务质量和效率，保障患者安全。公司拥有一支高素质的研发团队，以及完善的销售和服务网络，能够为客户提供全方位的技术支持和服务。</p>
            </div>
        </template>
   </layout-main>
 
   
 </template>
 <script>
 import layoutMain from '@/components/layout-main.vue'
 import banner from '@/assets/contactUs/banner.png'
 export default {
   name: 'JoinUs',
   components: {
     layoutMain
   },
   data () {
    return {
      

       banner: banner
    }
  },
 }
 </script>
 <style lang="scss" scoped>
 .about-us{
    min-height: 500px;
 }
 .title{ 
    text-indent: 0em;
    font-size: 22px;
    font-weight: 600;
    text-align: left;
    
}
.text{
    margin-top: 20px;
    text-indent: 0em;
    line-height: 2;
}
 </style>
 